import startOfDay from 'date-fns/startOfDay';
import getDate from 'date-fns/getDate';
import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import startOfToday from 'date-fns/startOfToday';
import addDays from 'date-fns/addDays';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export default {
  data() {
    return {
      todayDate: null,
      origin: null,
    };
  },
  created() {
    this.todayDate = startOfDay(new Date());
    this.origin = startOfToday();
  },
  computed: {
    timelineZoom: {
      get() {
        return this.$store.getters.getTimelineZoom;
      },
      set(value) {
        this.$store.dispatch('setTimelineZoom', value);
      },
    },
    dayWidth() {
      switch (this.timelineZoom) {
        case 'year':
          return 5;
        case 'quarter':
          return 10;
        case 'month':
          return 20;
        default:
          return 1;
      }
    },
    today() {
      const startDay = startOfDay(this.todayDate);
      return {
        date: startDay,
        position: this.preciseDateToPosition(this.todayDate),
        dayOfMonth: getDate(startDay),
      };
    },
    todayPosition() {
      return this.positionToLeft(this.today.position);
    },
  },
  methods: {
    positionToLeft(e) {
      return this.containerWidth / 2 + e;
    },
    positionToRight(e) {
      return this.containerWidth / 2 - e;
    },
    dateToPosition(date) {
      return this.dayWidth * differenceInCalendarDays(date, this.origin);
    },
    preciseDateToPosition(date) {
      const monthsDiff = differenceInCalendarMonths(startOfDay(date), this.origin);
      const timeOfDayInHours = getHours(date) + getMinutes(date) / 60;
      return this.dayWidth * (monthsDiff + timeOfDayInHours / 24);
    },
    positionToDate(position) {
      return addDays(this.origin, Math.round(position / this.dayWidth));
    },
  },
};
